let data = (typeof context !== 'undefined' ? context : {})

export const CONTEXT = data
export const API_URL = data.api_url || ''
export const LOCALE_PREFIX = data._locale?.prefix || ''
export const LOCALE_DATA = data._locale || {}
export const JOBS_URL = 'https://veocareers.recruitee.com/'
export const JOBS_LOCAL_URL = (LOCALE_PREFIX ? '/' : '') + `${LOCALE_PREFIX}/careers`
export const JOBS_PAGE_ANCHOR_ID = `jobs-page-list`

export const MAILTO = 'contact@veoworldwide.com'

export default {
  api_url: API_URL,
  jobs_url: JOBS_URL
}

export const EMPTY_IMAGE_SRC = '/images/admin/no_image.png'

export const HEADER_COMPONENT_KEY = 'header_component'
export const FOOTER_COMPONENT_KEY = 'footer_component'



